<app-document-type-grid (mySelected)='grid_onSelected($event)'></app-document-type-grid>
